module.exports = __webpack_public_path__ + "static/Avishek-6d18d6bcc0deb66700f458bccda3108f.jpg";